// extracted by mini-css-extract-plugin
module.exports = {"container":"MainSection3_container__zOf4_","inner_container":"MainSection3_inner_container__36_8X","value":"MainSection3_value__1K698","dummy":"MainSection3_dummy__3U8sG"};